import React from 'react';
import aboutImage from '../../assets/img/about.jpg'; // Adjust the path based on your project structure
import MarketingPageLayout from './MarketingPageLayout';
import TestimonialCarousel from './Testmonial';
import { Link } from 'react-router-dom';
import styles from './AboutUs.module.css';

const AboutUs: React.FC = () => (
  <MarketingPageLayout>
  <div className={`container-xxl ${styles.section}`}>
    <div className="container">
      <div className={`row g-5 align-items-center ${styles.heroCard}`}>
        <div className="col-md-5 col-sm-12 wow fadeIn" data-wow-delay="0.1s">
          <div className={styles.imageWrap}>
            <img className={styles.image} src={aboutImage} alt="About Us" />
          </div>
        </div>
        <div className="col-md-7 col-sm-12 wow fadeIn" data-wow-delay="0.5s">
          <div className={styles.content}>
          <p className={styles.kicker}>Our Story</p>
          <h2 className={styles.title}>About Us</h2>

          <h5 className={styles.subheading}>Our Vision</h5>
          <p className={styles.paragraph}>
            Our vision is a world where every person, regardless of their background, can effortlessly trace their roots,
            reconnect with loved ones, and preserve their unique family narratives. Through innovative technology and a
            commitment to humanitarian causes, we aspire to be the global leader in family unity, DNA discovery, and ancestral
            heritage celebration.
          </p>

          <h5 className={styles.subheading}>Our Mission</h5>
          <p className={styles.paragraph}>
            At iGiTREE, our mission is to bridge the gaps of time and distance, empowering individuals and communities to
            explore, discover, and celebrate their family heritage. We're dedicated to reuniting families, cultivating a sense
            of belonging, and nurturing the world's most precious connections.
          </p>
          <Link
              to="/dashboard"
              className={styles.cta}>
              Get Started
            </Link>
          </div>
        </div>
      </div>
   
    </div>
  </div>
  <TestimonialCarousel />
  </MarketingPageLayout>

);

export default AboutUs;                